<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    :title="rowInfo.id==''?'非公海订单设置':'非公海订单设置'"
    :loading="loading"
    @close="closeForm"
    width="500px">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="所属项目" prop="projectId">
               <select-text v-model="rowInfo.projectId" :multiple="false" code-set-id="" :options="projectOptions"  placeholder="所属项目" style="width:220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="所属城市" prop="cityCode">
              <el-select v-model="rowInfo.cityCode" clearable  multiple filterable placeholder="请选择所属城市" style="width:220px">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.codeItemId"
                  :label="item.codeName"
                  :value="item.codeItemId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addHighSeasInfo } from  "@/api/order/orderinfo"
import { citys } from '@/const/city.js'
import {loadProjectList} from "@/api/project";
import SelectText from '@/components/SelectText/index.vue'
export default {
  components: {
    SelectText
  },
  data() {
    return {
      visible: false,
      formName: '新增',
      loading: false,
      rowInfo: {
        projectId: "",
        cityCode: [],
        cityName: [],
      },
      projectOptions: [],
      cityOptions: citys,
      rules: {
        projectId: [{ required: true, message: '必填:所属项目', trigger: 'change' }],
        cityCode: [{ required: true, message: '必填:派单城市', trigger: 'change' }],
      }
    }
  },
  mounted() {
  },
  methods: {
    init() {
      this.visible = true
      loadProjectList().then(res => {
        this.projectOptions = res.data.data
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.rowInfo.cityCode.find(code => {
            let obj = {}
            obj = this.cityOptions.find(item => {
              return item.codeItemId === code //筛选出匹配数据
            })
            this.rowInfo.cityName.push(obj.codeName);
          })
          console.log(this.rowInfo.cityCode.join())
          console.log(this.rowInfo.cityName.join())
          addHighSeasInfo({projectId:this.rowInfo.projectId,cityCode:this.rowInfo.cityCode.join(),cityName:this.rowInfo.cityName.join()}).then((res) => {
            if (res.data.code==0) {
              // 在store中改变修改的值
              this.$message.success("添加成功")
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
              this.closeForm()
            }
          })
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
        cityCode: [],
        cityName: [],
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
